import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";

export class ProfileUserInformationEducationModel extends Model {
  constructor(
    public id: number = 0,
    public schoolName: string = "",
    public degree: string = "",
    public major: string = "",
    public currentlyStudyingFlag: boolean = false,
    public startDate: string = "",
    public endDate: string = "",
    public createdAt: string = "",
    public updatedAt: string = "",
  ) {
    super();
  }

  public static create(model: ProfileUserInformationEducationModel): ProfileUserInformationEducationModel {
    return createModel<ProfileUserInformationEducationModel>(ProfileUserInformationEducationModel, { ...model });
  }
}

export class ProfileEducationCreateModel {
  constructor(
    public id: number = 0,
    public schoolName: string = "",
    public degree: string = "",
    public major: string = "",
    public currentlyStudyingFlag: boolean = false,
    public startDate: string = "",
    public endDate: string = "",
  ) {
  }
}